export default __webpack_public_path__ + "static/media/small-lowest.670b47f8.svg";